import { IconProps } from "../../utils/global-types/global-types";

const FlaggedIcon = ({ className, ...rest}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M3.5 16a.5.5 0 0 1-.5-.5V3.13a.75.75 0 0 1 .372-.648C3.75 2.262 4.512 2 6 2c1.163 0 2.463.46 3.61.865.925.327 1.798.635 2.39.635a5.75 5.75 0 0 0 2.219-.453.562.562 0 0 1 .781.518v6.855a.63.63 0 0 1-.375.572c-.272.12-1.266.508-2.625.508-.754 0-1.7-.223-2.7-.46-1.124-.265-2.287-.54-3.3-.54-1.152 0-1.742.174-2 .285V15.5a.5.5 0 0 1-.5.5"
      ></path>
    </svg>
  );
};

export default FlaggedIcon;
